// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bNgrgwYT_c6Gshuo2HLO{background-color:var(--background-neutral-primary);border-radius:6px;width:100%;height:8px}.zhRBiXnYzp8aUcsLvHaw{background-image:linear-gradient(90deg,var(--background-neutral-primary)25%,var(--background-neutral-subtle)50%,var(--background-neutral-primary)75%);background-size:200% 100%;animation:1.4s ease-in-out infinite x_H_yAjn4nwns4mLsFrD}@media (prefers-reduced-motion:reduce){.zhRBiXnYzp8aUcsLvHaw{animation:none}}@keyframes x_H_yAjn4nwns4mLsFrD{0%{background-position:200% 0}to{background-position:-200% 0}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `bNgrgwYT_c6Gshuo2HLO`,
	"animated": `zhRBiXnYzp8aUcsLvHaw`,
	"shimmer": `x_H_yAjn4nwns4mLsFrD`
};
export default ___CSS_LOADER_EXPORT___;
